import axios from "axios";
import Cookies from "js-cookie";
import config from "../../config";

const Endpoint = "/api/comparativo-analisis-medicion";

const api = axios.create({
  baseURL: config.baseUrl,
});

api.interceptors.request.use(
  (config) => {
    const token = Cookies.get("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const getComparativoAnalisisMedicion = async (codigo) => {
  try {
    const response = await api.get(`${Endpoint}`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener la data:", error);
    throw error;
  }
};
export default getComparativoAnalisisMedicion;
